import { Button } from "@fluentui/react-components";
import { AddFilled, ArrowLeftFilled } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

type Props = {
  setCloseAddNewDep: () => void;
  setAddNewDependent: () => void;
  removeSelectedDependent: () => void;
  addNewDependent: boolean;
  selectedDependent: boolean;
};

export function EmployeeDependentsHeaderButton({
  addNewDependent,
  selectedDependent,
  setCloseAddNewDep,
  setAddNewDependent,
  removeSelectedDependent,
}: Props) {
  const { t } = useTranslation();

  if (addNewDependent) {
    return (
      <Button
        appearance="transparent"
        icon={<ArrowLeftFilled />}
        style={{
          width: "fit-content",
        }}
        onClick={() => {
          setCloseAddNewDep();
        }}
      >
        {t("greco.cancel")}
      </Button>
    );
  }

  if (!addNewDependent && !selectedDependent) {
    return (
      <Button
        style={{
          width: "fit-content",
        }}
        appearance="transparent"
        icon={<AddFilled />}
        onClick={() => {
          setAddNewDependent();
        }}
      >
        {t("hbh.addDependent.label")}
      </Button>
    );
  }

  if (selectedDependent) {
    return (
      <Button
        style={{
          width: "fit-content",
        }}
        appearance="transparent"
        icon={<ArrowLeftFilled />}
        onClick={() => {
          removeSelectedDependent();
        }}
      >
        {t("hbh.back.label")}
      </Button>
    );
  }

  return null;
}
